export const queryKeys = {
  baseConfig: () => ["base", "config"] as const,
  storageConfig: () => ["base", "storage-config"] as const,
  userInfo: () => ["user", "info"] as const,
  product: {
    detail: (channel: string, spuNo: string) => ["product", "detail", channel, spuNo] as const,
    search: (channel: string, keyword: string) => ["product", "search", channel, keyword] as const,
  },
} as const;
